import { IConfig } from "./Render";

export const SvgG = ({className, id, style, children, extraProps}:IConfig)=>
{   
    return (
           <g id={id} className={className} style={style} transform={extraProps.transform}>{children}</g>      
    );
}